import React, { useState } from 'react';
import SourcesManager from '../components/Admin/SourcesManager';
import LambdaStatus from '../components/Admin/LambdaStatus';
import ManualScraping from '../components/Admin/ManualScraping';
import AISolutionsApproval from '../components/Admin/AISolutionsApproval';
import ScrapedArticlesManager from '../components/Admin/ScrapedArticlesManager';
import './Admin.css';

const Admin: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'sources' | 'scraper' | 'articles' | 'manual-scraping' | 'ai-solutions' | 'scraped-articles'>('sources');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const handleLogin = () => {
    if (password === 'admin123') { // Change this to a secure password
      setIsAuthenticated(true);
      setLoginError('');
    } else {
      setLoginError('Invalid password');
      setTimeout(() => setLoginError(''), 3000);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-form">
          <h2>Admin Access</h2>
          <input
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
          />
          <button onClick={handleLogin}>Login</button>
          {loginError && <p style={{color: 'red', marginTop: '10px'}}>{loginError}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>News Scraper Administration</h1>
        <div className="admin-tabs">
          <button 
            className={activeTab === 'sources' ? 'active' : ''}
            onClick={() => setActiveTab('sources')}
          >
            Manage Sources
          </button>
          <button 
            className={activeTab === 'scraper' ? 'active' : ''}
            onClick={() => setActiveTab('scraper')}
          >
            Lambda Status
          </button>
          <button 
            className={activeTab === 'articles' ? 'active' : ''}
            onClick={() => setActiveTab('articles')}
          >
            Articles Info
          </button>
          <button 
            className={activeTab === 'scraped-articles' ? 'active' : ''}
            onClick={() => setActiveTab('scraped-articles')}
          >
            Edit Articles by Scrape
          </button>
          <button 
            className={activeTab === 'manual-scraping' ? 'active' : ''}
            onClick={() => setActiveTab('manual-scraping')}
          >
            Manual Scraping
          </button>
          <button 
            className={activeTab === 'ai-solutions' ? 'active' : ''}
            onClick={() => setActiveTab('ai-solutions')}
          >
            AI Solutions
          </button>
        </div>
      </div>

      <div className="admin-content">
        {activeTab === 'sources' && <SourcesManager />}
        
        {activeTab === 'scraper' && <LambdaStatus />}
        
        {activeTab === 'articles' && (
          <div className="admin-info">
            <h3>📰 Articles Management</h3>
            <p>Articles are now automatically approved and saved to the database when scraped. Use the "Edit Articles by Scrape" tab to manage existing articles.</p>
            <p><strong>Auto-approval is enabled</strong> - no manual approval needed.</p>
          </div>
        )}

        {activeTab === 'scraped-articles' && <ScrapedArticlesManager />}

        {activeTab === 'manual-scraping' && <ManualScraping />}
        
        {activeTab === 'ai-solutions' && <AISolutionsApproval />}
      </div>
    </div>
  );
};

export default Admin;
